import { Components, Theme, tooltipClasses } from '@mui/material';

export const getMuiTooltip = (theme: Theme): Components['MuiTooltip'] => ({
  styleOverrides: {
    tooltip: {
      color: theme.palette.text.primary,
      fontSize: 14,
      fontWeight: 'normal',
      borderRadius: theme.shape.borderRadiusSm,
      padding: '6px 12px',
      boxShadow: `0px 2px 5px rgba(31, 34, 38, 0.1), 0px 3px 15px rgba(31, 34, 38, 0.1)`,
      border: 'none',
      backgroundColor: theme.palette.background.paper,
      margin: 0,
      maxWidth: 260,
    },

    popper: {
      [`&[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
        marginBottom: theme.spacing(1),
      },

      [`&[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
        marginTop: theme.spacing(1.5),
      },

      [`&[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]: {
        marginTop: theme.spacing(1.5),
      },

      [`&[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]: {
        marginTop: theme.spacing(1.5),
      },
    },
  },
});
